export interface GuaranteeTypeOption {
  id: number;
}

export interface ResolveGuaranteeTypeIdOptions {
  autoSelectFirst?: boolean;
}

export function resolveGuaranteeTypeId(
  currentId: number | null,
  filteredTypes: GuaranteeTypeOption[],
  options?: ResolveGuaranteeTypeIdOptions
): number | null {
  if (filteredTypes.length === 0) {
    return null;
  }

  if (currentId != null && filteredTypes.some((gt) => gt.id === currentId)) {
    return currentId;
  }

  if (options?.autoSelectFirst) {
    return filteredTypes[0].id;
  }

  return null;
}

export const MONETIZATION_TYPE_ID_BY_OPERATION: Record<string, number> = {
  cheque: 1,
  préstamo: 2,
  prestamo: 2,
  pagaré: 3,
  pagare: 3,
  'commercial-endorsements': 4,
};
